"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { PRODUCTS_BINDING, PRODUCTS_BINDING_INPUT } from "@/libs/builder/consts";
import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

export const SecondaryNavigationComponent: RegisteredComponent = {
  name: "SecondaryNavigation",
  component: dynamic(async () => (await import("./SecondaryNavigation")).SecondaryNavigation),
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  inputs: [PRODUCTS_BINDING_INPUT],
  models: [getBuilderModelName("secondary-navigation")],
  childRequirements: {
    message: "Only Secondary Navigation related components are allowed",
    query: {
      "component.name": {
        $in: [
          "SimpleProductTeaser",
          "Columns",
          "List",
          "ShopTeaser",
          "ImageNavLinksList",
          "SubmenuTitle",
          "SubmenuBottomAction",
          "InnerContainer",
        ],
      },
    },
  },
  defaults: {
    bindings: PRODUCTS_BINDING,
  },
};
